/*
  Helium-Regeln fuer Ballons (26.10.2026, Plan docs/plans/2026-10-26-helium-ueberall.md).
  Vorher nur inline in snippets/pdw-ballon-extras.liquid; jetzt nutzen Artikelseite und
  Produktkarte (pdw-sortenwahl) dieselben Regeln, damit der Heliumpreis ueberall gleich ist.
  Fuellartikel = Kassenpositionen 1011-1039 (Handles unten).
*/
(function (g) {
  if (g.pdwHelium) return;

  // Groesse in cm aus einem Text: "Ø 43cm", "45x60cm", "36 cm", "18 inch", "1m".
  function cm(text) {
    if (!text) return 0;
    var m = /([0-9]{2,3})(?:[.,][0-9]+)? *(?:x *([0-9]{2,3})(?:[.,][0-9]+)? *)?cm/i.exec(text);
    if (m) return Math.max(+m[1], +(m[2] || 0));
    m = /([0-9]{2}) *(?:''|"|inch)/i.exec(text);
    if (m) return Math.round(+m[1] * 2.54);
    if (/(^|[^0-9])1 *m([^a-z0-9]|$)/i.test(text)) return 100;
    return 0;
  }

  // Stueckzahl eines Sets: "6 Stück", "6 Stk".
  function stueck(text) {
    var m = /([0-9]{1,2}) *-? *(?:st(?:ü|ue|u)ck|stk)/i.exec(text || '');
    return m ? +m[1] : 1;
  }

  // Kassenposition nach Kategorie und Groesse. Liefert
  // { nr } | { nein: true } | { anfrage: true }.
  function position(kat, titel, s) {
    var t = (titel || '').toLowerCase();
    if (kat === 'bubbles') return { nr: '1023' };
    if (!s) return { anfrage: true };
    if (kat === 'zahlbuch') {
      if (s === 36 || s === 41) return { nein: true };
      var z = { 66: '1011', 100: '1012', 102: '1012', 162: '1013', 163: '1013' }[s];
      return z ? { nr: z } : { anfrage: true };
    }
    if (kat === 'airwalker') {
      if (/walking/.test(t)) return { nr: '1031' };
      // Echte Airwalker (Batman, Bugs Bunny) fuellt der Laden immer zum
      // Preis 1033, auch ueber 100 cm (Stephan, 23.09.2026).
      return { nr: '1033' };
    }
    if (kat === 'latex' || kat === 'latexdruck') {
      if (s <= 13) return { nein: true }; // Stephan 29.10.2026: „Nimm 12cm raus“
      if (s >= 25 && s <= 33) {
        return { nr: (kat === 'latexdruck' || /chrome|bedruck|druck|konfetti|happy|safari/.test(t)) ? '1035' : '1036' };
      }
      if (s >= 43 && s <= 46) return { nr: '1015' };
      if (s >= 58 && s <= 62) return { nr: '1016' };
      if (s >= 88 && s <= 100) return { nr: '1017' };
      return { anfrage: true };
    }
    if (kat === 'herz') {
      if (s <= 48) return { nr: '1024' };
      if (s <= 60) return { nr: /herz/.test(t) ? '1038' : '1028' };
      if (s <= 80) return { nr: '1039' };
      if (/stern/.test(t)) return { nr: '1027' };
      if (/herz/.test(t)) return { nr: '1026' };
      return { nr: '1025' };
    }
    if (kat === 'motiv' || kat === 'schrift') {
      if (/wappen|emblem/.test(t)) return { nr: '1037' };
      if (s <= 47) return { nr: '1024' };
      if (s <= 90) return { nr: '1028' };
      if (s <= 100) return { nr: '1029' };
      if (s <= 150) return { nr: '1030' };
      return { anfrage: true };
    }
    return null;
  }

  // Kategorie fuer fremde Ballons aus "Passt dazu", nur aus Titel und Schlagwoertern.
  function katRaten(p) {
    var t = (p.title || '').toLowerCase();
    var tags = p.tags || [];
    if (tags.indexOf('Miniballons (Luftgeeignet)') > -1 || tags.indexOf('Standup Ballons (Luftgefüllt)') > -1) return '';
    if (/schriftzug|script/.test(t)) return '';
    if (/stand[ -]?up|minishape|(^|[^a-z])mini([^a-z]|$)/.test(t)) return '';
    if (/latex/.test(t)) return /bedruck|happy|motiv|safari|set/.test(t) ? 'latexdruck' : 'latex';
    if (/airwalker|walking/.test(t)) return 'airwalker';
    if (/bubble|orbz/.test(t)) return 'bubbles';
    if (/buchstabe|zahl([^a-z]|$)|zeichen/.test(t)) return 'zahlbuch';
    // 28.10.2026: einfarbige Herz/Stern/Rund wie in der Unterkategorie (56-cm-Herz 1038 statt Motiv 1028)
    if (/folien/.test(t)) return tags.indexOf('Einfarbige Folienballons') > -1 ? 'herz' : 'motiv';
    return '';
  }

  // Fuellartikel fuer einen Ballon, oder null. fuell = { '1028': { id, c }, ... }
  function fuellung(kat, titel, variantentitel, fuell) {
    if (!kat) return null;
    var s = cm(variantentitel && variantentitel !== 'Default Title' ? variantentitel : '') || cm(titel);
    var pos = position(kat, titel + ' ' + (variantentitel || ''), s);
    if (!pos || !pos.nr) return null;
    var f = fuell[pos.nr];
    return f ? { id: f.id, c: f.c, n: stueck(titel) } : null;
  }

  var FUELL = ['helium-66cm-zahlen-buchstaben-1011', 'helium-102cm-zahlen-buchstaben-1012', 'helium-162cm-zahlen-buchstaben-1013',
    'helium-45cm-latexballon-1015', 'helium-60cm-latexballon-1016', 'helium-90cm-latexballon-1017',
    'helium-bubble-orbz-1023', 'helium-45cm-folienballon-1024', 'helium-90cm-rund-1025', 'helium-90cm-herz-1026', 'helium-90cm-stern-1027',
    'helium-motiv-folienballon-48-90-cm-1028', 'helium-motiv-folienballon-91-100-cm-1029', 'helium-motiv-folienballon-101-150-cm-1030',
    'helium-walking-ballons-1031', 'helium-airwalker-bis-100cm-1033', 'helium-airwalker-ab-101cm-1034',
    'helium-30cm-chrome-bedruckte-latexballons-1035', 'helium-30cm-matt-pearl-metallic-latexballon-1036',
    'helium-motiv-folienballon-wappen-emblem-1037', 'helium-56cm-herz-folienballon-1038', 'helium-71cm-herz-rund-folienballon-1039'];
  var geholt = null;

  // Fuellpreise erst beim ersten Bedarf holen (Produktkarte); einmal je Seite.
  function fuellHolen() {
    if (geholt) return geholt;
    geholt = Promise.all(FUELL.map(function (h) {
      return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (ps) {
      var m = {};
      ps.forEach(function (p, i) {
        var v = p && p.variants && p.variants[0];
        if (v && v.available !== false) m[FUELL[i].split('-').pop()] = { id: v.id, c: v.price };
      });
      return m;
    });
    return geholt;
  }

  // Ballon + Fuellung als Warenkorb-Posten, gleiche Angaben wie die Artikelseite
  // (_pdw_k verbindet beide, _pdw_n = Stueck je Set; der Warenkorb erkennt daran Helium).
  var FUELLTEXT = 'Mit Helium gefüllt — nur Abholung im Laden';
  function posten(id, menge, f, fuer) {
    var b = { id: id, quantity: menge };
    if (!f) return [b];
    b.properties = { 'Füllung': FUELLTEXT, '_pdw_k': String(id) };
    return [b, { id: f.id, quantity: menge * f.n,
      properties: { 'Für': fuer, '_pdw_k': String(id), '_pdw_n': String(f.n) } }];
  }

  g.pdwHelium = { cm: cm, stueck: stueck, position: position, katRaten: katRaten, fuellung: fuellung, fuellHolen: fuellHolen, posten: posten };
})(typeof window !== 'undefined' ? window : globalThis);
